/**
 * PostHog Utility Functions
 * Works with globally loaded PostHog instance
 */

// Determine if we're in a development environment (same as in script-posthog.liquid)
const isDevEnvironment =
  window.isDevEnvironment === undefined ? false : window.isDevEnvironment;

/**
 * Experiment: Home Hero CTA Text
 */
document.addEventListener('DOMContentLoaded', function () {
  if (!window.posthog || isDevEnvironment) return;

  // Wait for feature flags to load before reading them
  window.posthog.onFeatureFlags(function () {
    const ctaVariant = window.posthog.getFeatureFlag('home-hero-cta-text');
    const ctaBannerLink = document.querySelector(
      'div[data-posthog="banner"] a'
    );

    // Only change text if we're showing the experimental variant
    if (ctaVariant === 'book-now' && ctaBannerLink) {
      ctaBannerLink.textContent = 'Book Now';
    }
  });
});
